import { type ReactNode } from "react";

import cx from "@hsl/core/utils/cx";

import {
    SubscribeIcon,
    WatchIcon,
} from "./SubscriptionButtons/SubscriptionButtons";

export function txStrReplacer(
    str: string,
    context?: { n?: number; iconClasses?: string; name?: string },
): ReactNode[] {
    const parts: ReactNode[] = [];
    const { n, iconClasses, name = "" } = context ?? {};
    const regex = /\[N\]|\[\[N\]\]|\[\^\]|\[\*\]|\[\[email\]\]|\[name\]/g;
    let lastIndex = 0;

    str.replace(regex, (match, index: number) => {
        const key = parts.length;
        parts.push(str.substring(lastIndex, index));

        switch (match) {
            case "[N]":
                parts.push(`${n}`);
                break;
            case "[[N]]":
                parts.push(<b key={key}>{n}</b>);
                break;
            case "[^]":
                parts.push(
                    <SubscribeIcon
                        key={key}
                        active
                        className={cx("mt-1 inline-block", iconClasses)}
                    />,
                );
                break;
            case "[*]":
                parts.push(
                    <WatchIcon
                        key={key}
                        active
                        className={cx("mt-1 inline-block", iconClasses)}
                    />,
                );
                break;
            case "[name]":
                parts.push(name);
                break;
            default:
                break;
        }

        lastIndex = index + match.length;
        return match;
    });

    parts.push(str.substring(lastIndex));

    return parts;
}

export const createFCSError = (
    status: number,
    tx?: (str: string) => { result: string },
) => {
    const HTTP500 =
        "Couldn't connect to LGIM Fund Collateral Subscriptions Service database. Please try again later.";
    const generic = "There was an error";
    const message = (() => {
        switch (status) {
            case 500:
                return HTTP500;
            default:
                return generic;
        }
    })();
    return new Error(tx?.(message).result ?? message);
};
